import { render, staticRenderFns } from "./CampoDecimalBase.vue?vue&type=template&id=369bb9a5&"
import script from "./CampoDecimalBase.vue?vue&type=script&lang=ts&"
export * from "./CampoDecimalBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports